import { del, get, post, put } from '../client';

export const equipmentTypesApi = {
  list: (params) => get('/equipment-types', { params }),
  getById: (id) => get(`/equipment-types/${id}`),
  create: (body) => post('/equipment-types', body),
  update: (id, body) => put(`/equipment-types/${id}`, body),
  remove: (id) => del(`/equipment-types/${id}`),
};
